function escapeRString(value) {
  return String(value === undefined || value === null ? '' : value)
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')
    .replace(/\n/g, '\\n');
}

function toRValue(value) {
  if (Array.isArray(value)) {
    return `c(${value.map(toRValue).join(', ')})`;
  }

  if (value && typeof value === 'object') {
    const entries = Object.entries(value)
      .map(([key, item]) => `${key} = ${toRValue(item)}`);
    return `list(${entries.join(', ')})`;
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  return `"${escapeRString(value)}"`;
}

function resultToRScript(result, signature) {
  return `# randFlow reproducible randomization export
# Generated at: ${escapeRString(result.timestamp)}
# Technique: ${escapeRString(result.algorithm)}
# Seed: ${escapeRString(result.seed)}
# Experiment signature: ${escapeRString(signature)}

randflow_metadata <- list(
  version = "${escapeRString(result.version)}",
  technique = "${escapeRString(result.algorithm)}",
  technique_id = "${escapeRString(result.algorithmId)}",
  seed = "${escapeRString(result.seed)}",
  generated_at = "${escapeRString(result.timestamp)}",
  parameters = ${toRValue(result.parameters)},
  validation = "${escapeRString(result.metrics.validation)}",
  imbalance = ${result.metrics.imbalance},
  imbalance_percent = ${result.metrics.imbalancePercent},
  experiment_signature = "${escapeRString(signature)}"
)

randflow_randomization <- data.frame(
  patient_id = c(${result.sequence.map((patient) => `"${escapeRString(patient.patientId)}"`).join(', ')}),
  sequence_order = c(${result.sequence.map((patient) => patient.sequenceOrder).join(', ')}),
  arm = c(${result.sequence.map((patient) => `"${escapeRString(patient.arm)}"`).join(', ')}),
  arm_index = c(${result.sequence.map((patient) => patient.armIndex + 1).join(', ')}),
  block = c(${result.sequence.map((patient) => patient.blockNumber === null || patient.blockNumber === undefined ? 'NA' : patient.blockNumber).join(', ')}),
  cluster = c(${result.sequence.map((patient) => patient.cluster ? `"${escapeRString(patient.cluster)}"` : 'NA').join(', ')}),
  stratum = c(${result.sequence.map((patient) => patient.stratum ? `"${escapeRString(patient.stratum)}"` : 'NA').join(', ')}),
  stringsAsFactors = FALSE
)

randflow_arm_summary <- as.data.frame(table(randflow_randomization$arm))
names(randflow_arm_summary) <- c("arm", "n")

print(randflow_metadata)
print(randflow_arm_summary)
`;
}

module.exports = {
  resultToRScript
};
